import { createApp } from "vue";
import { createPinia } from "pinia";
import { createRouter, createWebHashHistory } from "vue-router";

import Widgets from "./views/Widgets.vue";
import Leads from "./views/Leads.vue";
import Integrations from "./views/Integrations.vue";
import CustomCSS from "./views/CustomCSS.vue";
import WooCommerce from "./views/WooCommerce.vue";

import { routes } from './routes/widgets'
import { woocommerceRoutes } from './routes/woocommerce'

(() => {
    const Image = img => formychat_admin_vars.public + "images/" + img;

    // Widgets app
    if (document.getElementById('formychat-widgets')) {
        const widgetsApp = createApp(Widgets).use(createPinia());
        widgetsApp.config.globalProperties.Image = Image;
        widgetsApp.use(createRouter({
            history: createWebHashHistory(),
            routes: routes
        }));
        widgetsApp.mount("#formychat-widgets");
    }

    // Leads app
    if (document.getElementById('formychat-leads')) {
        const leadsApp = createApp(Leads).use(createPinia());
        leadsApp.config.globalProperties.Image = Image;
        leadsApp.mount("#formychat-leads");
    }

    // Integrations app
    if (document.getElementById('formychat-integrations')) {
        const integrationApp = createApp(Integrations).use(createPinia());
        integrationApp.config.globalProperties.Image = Image;
        integrationApp.mount("#formychat-integrations");
    }

    // Custom CSS app
    if (document.getElementById('formychat-custom-css')) {
        const customCSSApp = createApp(CustomCSS).use(createPinia());
        customCSSApp.config.globalProperties.Image = Image;
        customCSSApp.mount("#formychat-custom-css");
    }

    // WooCommerce app
    if (document.getElementById('formychat-woocommerce')) {
        const wooCommerceApp = createApp(WooCommerce).use(createPinia());
        wooCommerceApp.config.globalProperties.Image = Image;
        wooCommerceApp.use(createRouter({
            history: createWebHashHistory(),
            routes: woocommerceRoutes
        }));
        wooCommerceApp.mount("#formychat-woocommerce");
    }
})()